$(document).ready(function() {

    $('#cabezal').removeClass('no-btn');

    scroll();

    // Oculta header cuando el usuario scrollea hacia abajo y lo muestra cuando scrollea hacia arriba
    let didScroll;
    let lastScrollTop = 0;
    let delta = 5;
    let navbarHeight = $('header').outerHeight();

    $(window).scroll(function(event) {
        didScroll = true;



    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        let st = $(window).scrollTop();

        if (st > 60) {
            $('header').removeClass('nav-up');

            //bomba
            if ($('body.bomba').length) {
                $('header').removeClass('transparente');
            }


            //banner tercera
            if ($('header').hasClass('nav-down')) {
                $('.contenidos #mosaico .tercera #sticky').addClass('onTop');
            } else {
                $('.contenidos #mosaico .tercera #sticky').removeClass('onTop');
            }

            //titulo deportes
            if ($('.contenidos.deportes').length) {

                var titulo = $('.techo-1 h3 a')[0].textContent;
                var labelTitulo_fijo = document.querySelector('.titulo-fijo');
                if (labelTitulo_fijo) {
                    labelTitulo_fijo.innerHTML = titulo;
                }
            }

            //titulo indices
            if ($('main.indices').length) {

                var titulo = $('.encabezado > h1')[0].textContent;
                var labelTitulo_fijo = document.querySelector('.titulo-fijo');
                if (labelTitulo_fijo) {
                    labelTitulo_fijo.innerHTML = titulo;
                }
            }
        } else {
            $('header').addClass('nav-up');
            $('header').removeClass('nav-down');
            $('.banner-mobile.sticky2').removeClass('up');
            $('header').removeClass('acu-fijo');


            if ($('body.bomba').length) {
                $('header').addClass('transparente');
            }

            if ($('header.nav-up.nav-down').length) {
                $('header').removeClass('nav-down');
            }
            if ($('.anticipo').length) {
                $('#sticky').css('margin-bottom', '0');
            }

        }

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $('header').removeClass('nav-up').removeClass('nav-down');
        } else {
            // Scroll down
            if (st + $(window).height() < $(document).height()) {
                $('header').removeClass('nav-down').addClass('nav-down');
            }
        }
        if ($('header.nav-up.nav-down').length) {
            $('header').removeClass('nav-down');
        }
        if (st > 180) {


            //indices
            if ($('main.indices').length) {
                $('header').addClass('acu-fijo');
                $('header').removeClass('home');
            }

            if ($('header').hasClass('nav-down')) {
                $('.banner-mobile.sticky2').removeClass('up');
            } else {
                $('.banner-mobile.sticky2').addClass('up');
            }


            //deportes
            if ($('main.deportes').length) {
                if ($('header').hasClass('nav-down')) {
                    $('.banner-mobile.sticky2').addClass('up');
                    $('.banner-mobile.sticky2').css('top', '52px');
                    $('.scroll-links').slideDown();
                } else {
                    $('.banner-mobile.sticky2').addClass('up');
                    $('.banner-mobile.sticky2').css('top', '0px');
                    $('.scroll-links').slideUp();

                }



            }

        }

        lastScrollTop = st;

    }

    //ESTO ES EL MISMO QUE EST� EN COMMON, PERO CON EL HTML PLANO EL OTRO NO FUNCIONA, cuando lo tomen ustedes funcionar� con el common
    menu();
    menuBusqueda();
    modal();
    climaDesplegable();
    bombaGaleria();
    //if ($('.galeria').length) {
    //    sliderArticle(); //TODO: esto solo se usa para HTMLs de integracion 
    //}

    function menu() {

        //Apertura del menú
        $(".icon-menu-desktop").click(function(event) {
            if ($('header').hasClass('desplegado')) {
                $('.icon-menu-desktop').html('MEN&Uacute');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            } else {
                $('header').addClass('desplegado');
                $('.icon-menu-desktop').html('CERRAR');
            }

            if ($('header').hasClass('desplegado-busqueda') && $('.icon-menu-desktop').html('CERRAR')) {
                $('.icon-menu-desktop').html('MEN&Uacute');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }

            if ($(window).width() <= 768) {
                if ($('body').hasClass('sinScroll')) {
                    $('body').removeClass('sinScroll');
                } else {
                    $('body').addClass('sinScroll');
                }
            }
        });


        //Cierre del menú

        $('html').click(function(e) {
            if (e.target.id != 'header' && $(e.target).parents('header').length == 0) {
                if ($('header').hasClass('desplegado')) {
                    $('.icon-menu-desktop').html('MEN&Uacute');
                    $('header').removeClass('desplegado-busqueda');
                    $('header').removeClass('desplegado');
                } else {}
            }
        });


    }

    function menuBusqueda() {
        $('.busqueda input').focus(function() {
            $('header').addClass('desplegado');
            $('.icon-menu-desktop').html('CERRAR');
        });
    }

    function modal() {
        var modal = $('#modalImagen');
        var ampliar = $('.icon-ampliar');
        //Abre Modal
        ampliar.click(function() {
            let sliderContainer = $(this).parent('#sliderContainer');
            if (sliderContainer.length) {
                for (let img of sliderContainer.find('ul li img')) {
                    img.src = BucketTools.changeSizeWithFullPath(img.src, 'h1080');
                };
                $(this).parent().parent().addClass('elementoModal');
            } else {
                $(this).parent().find("img").attr("src", BucketTools.changeSizeWithFullPath($(this).parent().find("img").attr("src"), 'h1080'));
                $(this).parent().addClass('elementoModal');
            }

            if ($("body").hasClass('modal-on')) {
                exitFullScreen(elem);
                setTimeout(function() {
                    modal.fadeOut();
                    $('body').removeClass('modal-on');
                    $('.galeria').removeClass('elementoModal');
                    $('figure').removeClass('elementoModal');
                }, 300);

                var elem = document.body; // Make the body go full screen.

            } else {
                modal.fadeIn();
                $('body').addClass('modal-on');
                setTimeout(function() {
                    var elem = document.body; // Make the body go full screen.
                    requestFullScreen(elem);
                }, 300);
            }
        });
    }

    function climaDesplegable() {
        $(".clima h2").click(function(event) {
            $('body').addClass('climaOn');

            $('.climaDesplegable select').each(function() {
                var $this = $(this),
                    numberOfOptions = $(this).children('option').length;

                $this.addClass('select-hidden');
                $this.wrap('<div class="select"></div>');
                $this.after('<div class="select-styled"></div>');

                var $styledSelect = $this.next('div.select-styled');
                $styledSelect.text($this.children('option').eq(0).text());

                var $list = $('<ul />', {
                    'class': 'select-options'
                }).insertAfter($styledSelect);

                for (var i = 0; i < numberOfOptions; i++) {
                    $('<li />', {
                        text: $this.children('option').eq(i).text(),
                        rel: $this.children('option').eq(i).val()
                    }).appendTo($list);
                }

                var $listItems = $list.children('li');

                $styledSelect.click(function(e) {
                    e.stopPropagation();
                    $('div.select-styled.active').not(this).each(function() {
                        $(this).removeClass('active').next('ul.select-options').hide();
                    });
                    $(this).toggleClass('active').next('ul.select-options').toggle();
                });

                $listItems.click(function(e) {
                    e.stopPropagation();
                    $styledSelect.text($(this).text()).removeClass('active');
                    $this.val($(this).attr('rel'));
                    $list.hide();
                    //console.log($this.val());
                });

                $(document).click(function() {
                    $styledSelect.removeClass('active');
                    $list.hide();
                });

            });



        });

        $(".climaDesplegable .cerrar").click(function(event) {
            $('body').removeClass('climaOn');
        })
    }


    function bombaGaleria() {
        if ($('body.bomba .galeria').length) {
            $('main.contenidos').addClass('galeria-fix');
        }
    }




})


// WEBPACK FOOTER //
// ./Statics/scripts/home/functions.js